import {PropsWithChildren, useEffect} from 'react';
import store from 'store/dist/store.modern';
import {userSettingsVar} from '../../helpers/graphql/variables';

const UserSettingsProvider = ({children}: PropsWithChildren) => {
    useEffect(() => {
        const getInitialUserSettings = () => {
            if (!store.get('userSettings')) {
                store.set('userSettings', {});
            }

            return store.get('userSettings');
        };

        userSettingsVar(getInitialUserSettings());
    }, []);

    return (<>{children}</>);
};

export default UserSettingsProvider;
